import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-[var(--cor-borda)] bg-[var(--cor-fundo-2)]/40 mt-32" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-6 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <div className="font-display text-2xl tracking-wide text-[var(--cor-texto)]">
            salmos<span className="text-[var(--cor-dourado)]">.pt</span>
          </div>
          <p className="mt-4 font-serif text-[var(--cor-texto-2)] leading-relaxed max-w-xs">
            {t.footer_tagline}
          </p>
        </div>
        <div>
          <div className="font-display uppercase tracking-[0.22em] text-xs text-[var(--cor-dourado)] mb-5">{t.footer_navegar}</div>
          <ul className="space-y-3 font-serif text-[var(--cor-texto-2)]">
            <li><Link to="/salmos" className="hover:text-[var(--cor-dourado-claro)] transition-colors">{t.todos_salmos}</Link></li>
            <li><Link to="/categoria/ansiedade" className="hover:text-[var(--cor-dourado-claro)] transition-colors">{t.por_situacao}</Link></li>
            <li><Link to="/sobre" className="hover:text-[var(--cor-dourado-claro)] transition-colors">{t.sobre}</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-display uppercase tracking-[0.22em] text-xs text-[var(--cor-dourado)] mb-5">{t.footer_reflexao}</div>
          <p className="font-serif italic text-[var(--cor-texto-2)] leading-relaxed">
            "Bendize, ó minha alma, ao Senhor."
            <span className="block mt-2 not-italic text-xs uppercase tracking-widest text-[var(--cor-texto-2)]/70">— {t.salmo} 103</span>
          </p>
        </div>
      </div>
      <div className="border-t border-[var(--cor-borda)] py-6 text-center font-serif text-xs text-[var(--cor-texto-2)]">
        © {new Date().getFullYear()} salmos.pt — {t.direitos} · Criado por <a href="https://ruipinto.com" target="_blank" rel="noopener noreferrer" className="underline hover:opacity-80">ruipinto</a> · 2026
      </div>
    </footer>
  );
}
